import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load layouts
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const InvoiceLayout = lazy(() => import('@/pages/invoices/layout'));
const InvoiceDetailsLayout = lazy(() => import('@/pages/invoices/[invoiceId]/layout'));

// Lazy load invoice pages
const InvoicesPage = lazy(() => import('@/pages/invoices'));
const CreateInvoicePage = lazy(() => import('@/pages/invoices/create'));
const InvoiceDetailsPage = lazy(() => import('@/pages/invoices/[invoiceId]/details/invoice'));
const CreditMemoDetailsPage = lazy(() => import('@/pages/invoices/[invoiceId]/details/creditMemo'));

/**
 * Invoice routes
 * Handles invoice management
 */
export const invoiceRoutes: RouteConfig = {
  path: '/invoices',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: InvoiceLayout,
      element: InvoicesPage,
    },
    {
      path: '/create',
      layout: InvoiceLayout,
      element: CreateInvoicePage,
    },
    {
      path: '/:invoiceId',
      layout: InvoiceDetailsLayout,
      children: [
        {
          path: '/details/invoice',
          element: InvoiceDetailsPage,
        },
        {
          path: '/details/creditMemo',
          element: CreditMemoDetailsPage,
        },
      ],
    },
  ],
};
